import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-poster-simmer',
  templateUrl: './poster-simmer.component.html',
  styleUrls: ['./poster-simmer.component.css']
})
export class PosterSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
